/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, { useState, useEffect, useRef } from 'react';
import {useNavigate, useParams} from "react-router-dom";
import PageBox from "../../layouts/pageBox";
import SearchByModel from "../../components/SearchByModel";
import ListingTop from "../../components/ListingTop";
import ListingBottom from "../../components/ListingBottom";
import FiltersParts from "../../components/FiltersParts";
import PartBox from "../../components/PartBox";
import Loader from "../../elements/loader";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {useTranslation} from "react-i18next";
import SEO from "../../components/SEO";

const PartsListing = () => {

    let params = useParams();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const scrollTop = useRef(null);

    const isInitialSort = useRef(true);
    const isInitialParams = useRef(true);
    const isInitialSearch = useRef(true);

    const axiosJWT = useAxiosJTW();

    const queryParameters = new URLSearchParams(window.location.search);
    const _spec = queryParameters.get("spec");

    const [dataToSend, setDataToSend] = useState({
        page : 1,
        sort: 'date-desc',
        part: params.part,
        list: 1,
        limit: 50,
        spec: _spec
    });

    const [error, setError] = useState('');
    const [sortValue, setSortValue] = useState('date-desc');
    const [searchValue, setSearchValue] = useState({});

    const [parts, setParts] = useState({isLoading: true, data: [], error: false});
    const [partCategories, setPartCategories] = useState({isLoading: true, data: [], error: false});

    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);

    const data = {
        title: 'Used Parts',
        //subtitle: 'Breakers for parts Alfa Romeo 159 Air Cleaner Box'
    };

    const getlistpartcategories = (dataToSend, signal) => {

        axiosJWT.post('api/getlistpartcategories', dataToSend, {signal}).then( (response) => {

            if(response.status === 200){

                if( response.data.part_categories ){
                    setPartCategories({...partCategories, data: response.data.part_categories || [], isLoading: false});
                }

            }
        } ).catch((error) => {
            console.log(error);
            if(error.code != 'ERR_CANCELED'){
                setError('An error occurred please try again later.');
            }
        });

    }

    const getPartsListingByPart = (dataToSend, signal) => {
        axiosJWT.post('api/getpartslistingbypart', dataToSend, {signal}).then( (response) => {

            if(response.status === 200){

                setParts({...parts, data: response.data.parts.parts || [], isLoading: false});

                // if( response.data.part_categories ){
                //     setPartCategories({...partCategories, data: response.data.part_categories || [], isLoading: false});
                // }

                setTotalPages( parseInt(response.data.total_pages) || 1 );
                setTotalItems(  parseInt(response.data.total_parts) );

            }
        } ).catch((error) => {
            console.log(error);
            if(error.code != 'ERR_CANCELED'){
                setError('An error occurred please try again later.');
            }
        });

    }

    useEffect(() => {
        setParts({...parts, isLoading: true});
        const controller = new AbortController();
        const signal= controller.signal;

        getlistpartcategories( dataToSend, signal);
        getPartsListingByPart( dataToSend, signal);

        return () => {controller.abort();}
    }, [dataToSend]);

    useEffect(() => {
        if (isInitialParams.current) {
            isInitialParams.current = false;
        } else {

            const queryParameters = new URLSearchParams(window.location.search);
            const _spec = queryParameters.get("spec");

            setDataToSend(prevState => ({
                ...prevState,
                page: 1,
                part: params.part,
                spec: _spec
            }));
        }
    }, [params]);

    useEffect(() => {
        if (isInitialSort.current) {
            isInitialSort.current = false;
        } else {
            setDataToSend(prevState => ({
                ...prevState,
                page: 1,
                sort: sortValue
            }));
        }
    }, [sortValue]);

    useEffect(() => {
        if (isInitialSearch.current) {
            isInitialSearch.current = false;
        } else {
            navigate(`/${i18n.language}/parts/listing/${searchValue.makes}/${searchValue.models}/${encodeURIComponent(params.part)}/${searchValue.yearRange}?bodytype=${searchValue.type}`);
            // setDataToSend(prevState => ({
            //     ...prevState,
            //     page: 1,
            //     make: searchValue.makes,
            //     model: searchValue.models,
            //     part: params.part,
            //     year: searchValue.year,
            //     list: null
            // }));

        }
    }, [searchValue]);


    return (
        <PageBox data={data}>
            <SEO
                title={t('meta_title.partsListingAll', {partname: params.part})}
                description={t('meta_description.partsListingAll', {partname: params.part})}
            />
            <div className='page-body'>
                <div ref={scrollTop} className='page-row'>
                    <div className='page-sidebar'>
                        {partCategories.isLoading ? (
                            <div style={{ paddingTop: '30px', textAlign : 'center' }}><Loader/></div>
                        ) : (
                            <FiltersParts categoriesAll={partCategories.data}/>
                        )}
                    </div>
                    <div className='page-content'>

                        <SearchByModel search={setSearchValue}/>
                        <ListingTop onSort={setSortValue} value={sortValue} count={totalItems}/>

                        <div className='partBoxs'>
                            {parts.isLoading ? (
                                <>
                                    <div style={{ paddingTop: '30px', textAlign : 'center' }}><Loader/></div>
                                    <div style={{ paddingTop: '30px', textAlign : 'center', color: 'red' }}>{error}</div>
                                </>
                            ) : (
                                parts.data.map((item, index) => {
                                    return (
                                        <PartBox key={index} part={item} link={`/${i18n.language}/used-part/${encodeURIComponent(item.slug)}/${item.make_slug}/${item.model_slug}/${item.year_slug}/${item.city_slug}/${item.part_code}`}/>
                                    );
                                })
                            )}
                        </div>

                        <ListingBottom currentPage={dataToSend.page} totalPages={totalPages} onChangePage={setDataToSend} scrollTop={scrollTop}/>

                    </div>
                </div>
            </div>
        </PageBox>
    );
};

export default PartsListing;
